import React, { useEffect, useState } from "react";
import useUpdateEffect from "../../../../hooks/useUpdateEffect";
import checkCollisions from "../../../../utils/checkCollisions";
import TaskList from "../Task/TaskList.js";
import UserRow from "./UserRow.js";
/**
 * Component to render a row in the content section containing user information and their tasks.
 * @param {Object} props - The props object containing user data and task click handler.
 * @param {Object} props.user - The user object containing user data.
 * @param {Function} props.taskClick - The function to handle task click event.
 * @param {number} props.calendarHeightIncrease - Additional height to add to calendar (for user role view).
 * @param {boolean} props.hideUserName - Whether to hide the user name sidebar.
 * @param {boolean} props.hideCountryside - Whether to hide the countryside part in task display (show title only).
 * @returns {JSX.Element} - Returns JSX for the content row.
 */
const ContentRow = ({ user, hideTimeline = false, onTaskClick = null, calendarHeightIncrease = 0, hideUserName = false, hideCountryside = false, dates = null, columnWidth = null }) => {
  const [taskWrapContainerHeight, setTaskWrapContainerHeight] = useState(0); // State for storing the height of task wrapper container
  const [users, setUsers] = useState([]); // State for storing user IDs to track if user data has been processed
  // Custom hook to handle side effect of updating user data
  useEffect(() => {
    // Check if user data exists and is not already processed
    if (user && !users.includes(user.userId)) {
      // Calculate total height of tasks container and update state
      const totalHeight = checkCollisions(user.tasks, user.userId, "assigned");
      setTaskWrapContainerHeight(totalHeight > 0 ? totalHeight + 80 : 0);
      // Update list of processed user IDs
      setUsers((prevUsers) => [...prevUsers, user.userId]);
    }
  }, [user, users]); // Dependencies for the effect

  // Calculate final height with calendar height increase
  const finalHeight = taskWrapContainerHeight + calendarHeightIncrease;

  // Render the content row with user information and tasks
  return (
    <div className="row" key={user.userId}>
      {!hideUserName && (
        <div className="user-name">
          {user.firstname} <br /> {user.lastname}
        </div>
      )}
      <div
        className="year"
        style={{ minHeight: `${finalHeight}px`, height: "auto" }}
      >
        <UserRow user={user} hideTimeline={hideTimeline} dates={dates} columnWidth={columnWidth} /> {/* Render UserRow component */}
        <TaskList user={user} onTaskClick={onTaskClick} hideCountryside={hideCountryside} dates={dates} columnWidth={columnWidth} /> {/* Render TaskList component */}
      </div>
    </div>
  );
};

export default ContentRow;
